<template>
  <div class="step-result">
    <div class="step-result no-result-info" v-if="bikesCount === 0">
      <span>
        {{ $t("result.noResultDesc") }}
      </span>
    </div>
    <div class="step-result found-info" v-if="bikesCount > 0 && bestSellers">
      <i18n path="result.noResultButBestsellersDesc">
        <template v-slot:count>
          <span class="count">{{ 0 }}</span>
        </template>
        <template v-slot:bikeX>
          {{ bikePlural(0) }}
        </template>
        <template v-slot:break>
          <br />
        </template>
      </i18n>
    </div>
    <div v-if="bikesCount > 0 && !bestSellers" class="step-result found-info">
      <div v-if="!lastStep">
        <i18n path="result.foundResultDesc">
          <template v-slot:count>
            <span class="count">{{ bikesCount }}</span>
          </template>
          <template v-slot:bikeX>
            {{ bikePlural(bikesCount) }}
          </template>
          <template v-slot:break>
            <br />
          </template>
        </i18n>
      </div>
      <div v-else>
        <i18n path="result.foundResultAndLastStepDesc">
          <template v-slot:count>
            <span class="count">{{ bikesCount }}</span>
          </template>
          <template v-slot:bikeX>
            {{ bikePlural(bikesCount) }}
          </template>
        </i18n>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ResultInfo",
  props: {
    bikesCount: {
      type: Number,
      required: false,
      default: 0,
    },
    bestSellers: {
      type: Boolean,
      required: false,
      default: false,
    },
    lastStep: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    bikePlural: function (value) {
      if (value === 1) {
        return this.$t("result.bikeSingularNominativ");
      } else if (
        value % 10 >= 2 &&
        value % 10 <= 4 &&
        (value % 100 < 10 || value % 100 >= 20)
      ) {
        return this.$t("result.bikePluralNominativ");
      } else {
        return this.$t("result.bikePluralGenitive");
      }
    },
  },
};
</script>
